@if (loading) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}

@if (hasFullContenedoresAccess()) {
  <div class="dashboard">

    <section class="kpi-grid">
      <button class="kpi-card kpi-summary" (click)="navigateToEstado('all')">
        <div class="kpi-summary-left">
          <mat-icon class="kpi-summary-icon">inventory_2</mat-icon>
          <div class="kpi-body">
            <span class="kpi-value">{{ total }}</span>
            <span class="kpi-label">Total</span>
          </div>
        </div>
        <div class="kpi-summary-divider"></div>
        <div class="kpi-summary-right">
          <mat-icon class="kpi-summary-icon">trending_up</mat-icon>
          <div class="kpi-body">
            <span class="kpi-value">{{ disponibilidad }}%</span>
            <span class="kpi-label">Disponibilidad</span>
          </div>
        </div>
      </button>

      @for (estado of estados; track estado.key) {
        <button class="kpi-card" [style.--kpi-color]="estado.color" (click)="navigateToEstado(estado.key)">
          <mat-icon>{{ estado.icon }}</mat-icon>
          <div class="kpi-body">
            <span class="kpi-value">{{ counts[estado.key] }}</span>
            <span class="kpi-label">{{ estado.label }}</span>
          </div>
        </button>
      }
    </section>

    <section class="quick-actions">
      <div class="quick-buttons">
        <div class="quick-buttons-left">
          <button mat-stroked-button color="primary" routerLink="/contenedores-adm">
            <mat-icon>list</mat-icon> Ver todos
          </button>
          <button mat-stroked-button color="primary" routerLink="/contenedores-mov">
            <mat-icon>sync_alt</mat-icon> Movimientos
          </button>
          <button mat-stroked-button color="primary" routerLink="/contenedores-mtn">
            <mat-icon>handyman</mat-icon> Mantenimientos
          </button>
        </div>

        <div class="quick-buttons-right">
          <button mat-stroked-button color="primary" (click)="newContenedor()">
            <mat-icon>add</mat-icon> Alta contenedor
          </button>
          @if (canAltaMovimiento()) {
            <button mat-stroked-button color="primary" (click)="newMovimiento()">
              <mat-icon>add</mat-icon> Alta movimiento
            </button>
          }
          @if (canAltaMantenimiento()) {
            <button mat-stroked-button color="primary" (click)="newMantenimiento()">
              <mat-icon>add</mat-icon> Alta mantenimiento
            </button>
          }
        </div>
      </div>
    </section>

    <section class="main-grid">
      <mat-card class="panel chart-panel">
        <mat-card-header>
          <mat-card-title>Estado de contenedores</mat-card-title>
          <mat-card-subtitle>Distribución por situación actual</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <div class="chart-layout">
            <div class="chart-wrapper">
              <canvas
                baseChart
                [type]="'doughnut'"
                [data]="doughnutChartData"
                [options]="doughnutChartOptions"
                (chartClick)="onChartClick($event)">
              </canvas>
              <div class="chart-center">
                <span class="chart-center-value">{{ total }}</span>
                <span class="chart-center-label">Total</span>
                <span class="chart-center-sub">{{ activos }} activos</span>
              </div>
            </div>

            <div class="legend-list">
              @for (item of legendItems; track item.key) {
                <button class="legend-item" (click)="navigateToEstado(item.key)">
                  <span class="legend-dot" [style.background]="item.color"></span>
                  <span class="legend-label">{{ item.label }}</span>
                  <span class="legend-count">{{ item.count }}</span>
                  <span class="legend-pct">{{ item.percentLabel }}</span>
                </button>
              }
            </div>
          </div>

          <mat-divider class="section-divider"></mat-divider>

          <div class="section-header">
            <span class="section-title">En mantenimiento activo</span>
            <button mat-button color="primary" routerLink="/contenedores-mtn">Ver todos</button>
          </div>

          @if (mantenimientosActivos.length === 0) {
            <p class="alert-empty">No hay mantenimientos pendientes.</p>
          } @else {
            <ul class="alert-list">
              @for (m of mantenimientosActivos; track m.idMantenimiento) {
                <li class="alert-row" (click)="viewContenedor(m.idContenedor)">
                  <span class="alert-matricula">{{ m.matricula }}</span>
                  <span class="alert-meta">{{ getMantenimientoEstadoLabel(m.estado) }} · {{ m.fechaAccion }}</span>
                </li>
              }
            </ul>
          }
        </mat-card-content>
      </mat-card>

      <mat-card class="panel alerts-panel">
        <mat-card-content>
          <div class="section-header">
            <span class="section-title">Últimos movimientos</span>
            <button mat-button color="primary" routerLink="/contenedores-mov">Ver todos</button>
          </div>

          @if (ultimosMovimientos.length === 0) {
            <p class="alert-empty">No hay movimientos registrados.</p>
          } @else {
            <ul class="activity-list">
              @for (mov of ultimosMovimientos; track mov.id) {
                <li class="activity-row">
                  <span class="activity-tipo" [class]="mov.tipo">{{ getMovimientoTipoLabel(mov.tipo) }}</span>
                  <span class="activity-main">{{ getMovimientoLabel(mov) }}</span>
                  <span class="activity-meta">{{ mov.cliente || '—' }} · {{ mov.fecha }}</span>
                </li>
              }
            </ul>
          }
        </mat-card-content>
      </mat-card>
    </section>

  </div>
} @else if (canAccessContenedoresLimitado()) {
  <div class="dashboard dashboard--limitado">
    <h2 class="limitado-title">Contenedores</h2>

    <section class="quick-actions">
      <div class="quick-buttons limitado-buttons">
        @if (canAltaMovimiento()) {
          <button mat-stroked-button color="primary" (click)="newMovimiento()">
            <mat-icon>add</mat-icon> Alta movimiento
          </button>
        }
        @if (canAltaMantenimiento()) {
          <button mat-stroked-button color="primary" (click)="newMantenimiento()">
            <mat-icon>add</mat-icon> Alta mantenimiento
          </button>
        }
      </div>
    </section>
  </div>
}
